import { withRouter } from 'react-router'
import Footer from '../components/Footer'
import { connect } from 'react-redux'
import { compose, graphql } from 'react-apollo';
import { getFooter } from "../graphqlDic";

export default compose(
    graphql(getFooter,{
        name:'getFooter'
    })
)(withRouter(
    connect(
        null,
        null
    )(Footer)
));



// WEBPACK FOOTER //
// ./src/containers/GetFooter.js